const defaultHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
};

export default defaultHeaders;
